import './spinner.css';

// Two orbiting dots loader, ported from the lil-story-b2c Spinner component.
const Spinner = ({ size = 35, color = 'black', speed = '1.5s' }) => (
    <div
        className="orbit-spinner"
        style={{
            '--uib-size': `${size}px`,
            '--uib-color': color,
            '--uib-speed': typeof speed === 'number' ? `${speed}s` : speed,
        }}
    />
);

export default Spinner;
